import React, { useState } from 'react';
import Table from 'components/Form/Table';
import Badge from 'components/Badge';
import moment from 'moment';
import Pagination from 'components/common/pagination';
import styles from './products.module.scss';
import angleRight from 'assets/images/angle-right.png';
import { useHistory } from 'react-router';
import { statusTextColorMapping } from 'libs';
import { useDispatch } from 'react-redux';

const ProductTableView = ({
  products,
  meta,
  pagination,
  fetchProducts,
  testid,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const history = useHistory();
  const dispatch = useDispatch();
  const view = (code) => {
    history.push(`/products/view/${code}`);
  };

  // Change page
  function handlePageClick(data) {
    setCurrentPage(data.selected + 1);
    dispatch(fetchProducts({ ...pagination, page: data.selected }));
  }

  return (
    <div className={styles.tableTop} data-testid={testid}>
      <Table>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Status</Table.Th>
            <Table.Th>PRODUCT TITLE</Table.Th>
            <Table.Th>DATE CREATED</Table.Th>
            <Table.Th>CATEGORY</Table.Th>
            <Table.Th>DATE UPDATED</Table.Th>
            <Table.Th> </Table.Th>
          </Table.Tr>
        </Table.Thead>

        <Table.TBody>
          {products &&
            products.length > 0 &&
            products.map((item, index) => (
              <Table.Tr key={index}>
                <Table.Td>
                  <Badge color={statusTextColorMapping[item.status]?.color}>
                    {statusTextColorMapping[item.status]?.text}
                  </Badge>
                </Table.Td>
                <Table.Td>{item.title}</Table.Td>
                <Table.Td>
                  {moment(item.createdAt).format('DD MMMM YYYY')}
                </Table.Td>
                <Table.Td>{item.businessSector?.name}</Table.Td>
                <Table.Td>
                  {moment(item.createdAt).format('DD MMMM YYYY')}
                </Table.Td>
                <Table.Td>
                  <img
                    src={angleRight}
                    alt="angleRight"
                    onClick={() => view(item.code)}
                    data-testid="click-details-list"
                  />
                </Table.Td>
              </Table.Tr>
            ))}
        </Table.TBody>
      </Table>

      <div className={styles.page}>
        <p>
          Showing {products?.length} items out of {meta?.total} results found
        </p>
        <div>
          <Pagination
            testid="paginate"
            handlePageClick={handlePageClick}
            totalItems={Math.ceil(meta?.total / meta?.limit)}
            currentPage={currentPage}
          />
        </div>
      </div>
    </div>
  );
};

export default ProductTableView;
